import React from "react";
import {useTranslation} from "react-i18next";
import {useB2BAgencyStats} from "../hooks/useB2BAgencyStats.ts";
import {AgencyStatsSection} from "./agencyDetail/AgencyStatsSection.tsx";

interface MyAgencyOverviewContainerProps {
    agencyId: string
    setPath?: (path: string) => void
}

// "Vista general" tab for a logged-in agency user: reuses the same stats view
// already built for the tourOperator staff "Estadísticas" tab, backed by the
// self-service /me/stats and /me/tripbooks endpoints instead of the staff ones.
export const MyAgencyOverviewContainer: React.FC<MyAgencyOverviewContainerProps> = ({agencyId, setPath}) => {
    const {t} = useTranslation('dashboard')
    const {stats, isLoadingStats} = useB2BAgencyStats(agencyId, true)

    return (
        <div className="h-full overflow-y-auto no-scrollbar">
            <header className="pb-5">
                <h1 className="text-[26px] font-semibold tracking-tight text-neutralBlack-900">{t('overview')}</h1>
            </header>
            <AgencyStatsSection
                agencyId={agencyId}
                stats={stats}
                isLoading={isLoadingStats}
                isSelfService
                onViewAllTripbooks={setPath ? () => setPath('tripbooks') : undefined}
                onViewReferrals={setPath ? () => setPath('referrals') : undefined}
            />
        </div>
    )
}
